if (!customElements.get('collection-layout-switch')) {
  const DESKTOP_COL_CLASSES = [
    'grid--1-col-desktop',
    'grid--2-col-desktop',
    'grid--3-col-desktop',
    'grid--4-col-desktop',
    'grid--5-col-desktop',
    'grid--6-col-desktop',
  ];
  const MOBILE_COL_CLASSES = ['grid--1-col-tablet-down', 'grid--2-col-tablet-down'];

  class CollectionLayoutSwitch extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById(this.getAttribute('aria-controls'));
      if (!this.grid) return;

      this.device = this.getAttribute('device');
      this.storageKey = `collection-layout-${this.device}`;
      const saved = localStorage.getItem(this.storageKey);
      const initial = saved || this.getAttribute('data-default');

      if (initial) {
        this.applyLayout(initial);
        this.setActiveButton(initial);
      }

      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[type="button"]');
        if (!button || button.classList.contains('is-active')) return;

        this.applyLayout(button.value);
        this.setActiveButton(button.value);
        localStorage.setItem(this.storageKey, button.value);
      });
    }

    applyLayout(value) {
      if (this.device === 'desktop') {
        DESKTOP_COL_CLASSES.forEach((className) => this.grid.classList.remove(className));

        if (value === 'four') this.grid.classList.add('grid--4-col-desktop');
        else if (value === 'three') this.grid.classList.add('grid--3-col-desktop');
      } else {
        MOBILE_COL_CLASSES.forEach((className) => this.grid.classList.remove(className));

        if (value === 'one') this.grid.classList.add('grid--1-col-tablet-down');
        else if (value === 'two') this.grid.classList.add('grid--2-col-tablet-down');
      }
    }

    setActiveButton(value) {
      this.querySelectorAll('button[type="button"]').forEach((button) => {
        button.classList.toggle('is-active', button.value === value);
      });
    }
  }

  customElements.define('collection-layout-switch', CollectionLayoutSwitch);
}
